const TOAST_DURATION = 10000;

export const showToast = (message, status = false, duration = TOAST_DURATION) => {
  const container = document.querySelector('.toast-global-container');
  if (!container) return;

  const config = status
    ? {
        bgColor: '#f0fdf4',
        borderColor: '#22c55e',
        iconBg: '#dcfce7',
        iconColor: '#15803d',
        icon: '✓',
        label: 'Success',
        labelColor: '#15803d',
        progressColor: '#22c55e',
      }
    : {
        bgColor: '#fef2f2',
        borderColor: '#ef4444',
        iconBg: '#fee2e2',
        iconColor: '#dc2626',
        icon: '✕',
        label: 'Error',
        labelColor: '#dc2626',
        progressColor: '#ef4444',
      };

  const toastId = 'toast-' + Date.now() + '-' + Math.random();

  const toastHtml = `
    <div id="${toastId}" class="catchy-toast" style="
      background: ${config.bgColor};
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      border-left: 4px solid ${config.borderColor};
      margin-top: 10px;
      width: 500px;
      max-width: calc(100vw - 32px);
      box-shadow: 0 4px 16px rgba(0,0,0,0.07), 0 1px 4px rgba(0,0,0,0.04);
      animation: toastSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
      overflow: hidden;
      cursor: pointer;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    ">
      <div style="display: flex; align-items: flex-start; padding: 14px 16px; gap: 12px;">

        <div style="
          background: ${config.iconBg};
          color: ${config.iconColor};
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 700;
          flex-shrink: 0;
          margin-top: 1px;
        ">
          ${config.icon}
        </div>

        <div style="flex: 1; min-width: 0;">
          <div style="
            font-size: 14px;
            font-weight: 600;
            color: ${config.labelColor};
            margin-bottom: 2px;
            letter-spacing: 0.01em;
          ">${config.label}</div>
          <div style="
            font-size: 13px;
            color: #374151;
            line-height: 1.5;
            word-break: break-word;
          ">${message}</div>
        </div>

        <button onclick="event.stopPropagation(); document.getElementById('${toastId}').style.animation='toastSlideOut 0.2s ease forwards'; setTimeout(()=>{ const el=document.getElementById('${toastId}'); if(el) el.remove(); }, 200)" style="
          background: none;
          border: none;
          color: #9ca3af;
          cursor: pointer;
          font-size: 16px;
          width: 28px;
          height: 28px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          padding: 0;
          margin-top: 1px;
          transition: all 0.15s ease;
        "
        onmouseover="this.style.color='#374151'; this.style.background='rgba(0,0,0,0.05)'"
        onmouseout="this.style.color='#9ca3af'; this.style.background='none'"
        aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div style="height: 3px; background: rgba(0,0,0,0.06);">
        <div style="
          height: 100%;
          width: 100%;
          background: ${config.progressColor};
          border-radius: 0 0 12px 12px;
          animation: toastShrink ${duration / 1000}s linear forwards;
        "></div>
      </div>
    </div>
  `;

  container.insertAdjacentHTML('beforeend', toastHtml);

  const toastElement = document.getElementById(toastId);
  if (toastElement) {
    toastElement.onclick = (e) => {
      if (e.target.tagName !== 'BUTTON' && !e.target.closest('button')) {
        toastElement.style.animation = 'toastSlideOut 0.2s ease forwards';
        setTimeout(() => { if (toastElement) toastElement.remove(); }, 200);
      }
    };
  }

  setTimeout(() => {
    const el = document.getElementById(toastId);
    if (el) {
      el.style.animation = 'toastSlideOut 0.2s ease forwards';
      setTimeout(() => { if (el) el.remove(); }, 200);
    }
  }, duration);
};

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes toastSlideIn {
      from { transform: translateX(110%); opacity: 0; }
      to   { transform: translateX(0);   opacity: 1; }
    }
    @keyframes toastSlideOut {
      from { transform: translateX(0);   opacity: 1; }
      to   { transform: translateX(110%); opacity: 0; }
    }
    @keyframes toastShrink {
      from { width: 100%; }
      to   { width: 0%;   }
    }

    /* Optional: Add hover effect for better UX */
    .catchy-toast:hover {
      box-shadow: 0 8px 24px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06) !important;
      transform: translateY(-1px);
      transition: all 0.2s ease;
    }
  `;
  document.head.appendChild(style);
}